import {action, makeAutoObservable, observable, runInAction} from "mobx";
import {newPasswordStore} from './NewPasswordStore'
import VisiblPass from '../../../img/invisiblePass.png'
import InvisPass from '../../../img/visibilityPass.png'

class ConfirmPasswordStore {
    password = "";
    @observable passwordValid = "";
    @observable HelpText = "";
    @observable inputType = 'password';
    @observable imgEye = VisiblPass
    @observable visibleFlag = true;

    @action eyeClcik = () => {
        if(this.visibleFlag){
            this.inputType = 'text';
            this.imgEye = InvisPass
        } else {
            this.inputType = 'password';
            this.imgEye = VisiblPass
        }
        this.visibleFlag = !this.visibleFlag;
    }

    constructor() {
        makeAutoObservable(this);
    }

    @action UserKeyDown(passwordValid="", HelpText=""){
        this.passwordValid = passwordValid;
        this.HelpText = HelpText;
    }

    SetPassword = (e) => {
        this.password = e.target.value;
        this.UserKeyDown();
    }

    ValidPassword(){
        if(this.password.length === 0){
            runInAction(() => {this.UserKeyDown('is-invalid', 'Укажите пароль длинной более 3 символов');})
        } else if(this.password === newPasswordStore.password){
            runInAction(() => {this.UserKeyDown();})
        } else {
            runInAction(() => {this.UserKeyDown('is-invalid', 'Пароли не совпадают');})
        }
    }

    get GetPassword(){
        this.ValidPassword();
        if(this.passwordValid === "is-invalid"){
            return "";
        } else {

            return this.password;
        }
    }


    @action Clear(){
        this.password = "";
        this.HelpText = "";
        this.passwordValid = "";
        this.visibleFlag = true;
        this.inputType = 'password';
        this.imgEye = VisiblPass;
    }
}

export const confirmPasswordStore = new ConfirmPasswordStore();